/**
 * 班级卡片
 */
export default {
  groupBuy: 'Group Buy',
}
